import { render, staticRenderFns } from "./Security.vue?vue&type=template&id=1a61d3f9&scoped=true"
import script from "./Security.vue?vue&type=script&lang=js"
export * from "./Security.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a61d3f9",
  null
  
)

export default component.exports